export default __webpack_public_path__ + "static/media/design--dotted-raster--ffffff-clean--R.58eebfeb.png";